import { render, staticRenderFns } from "./_task_info.vue?vue&type=template&id=4ad75a43&scoped=true"
import script from "./_task_info.vue?vue&type=script&lang=js"
export * from "./_task_info.vue?vue&type=script&lang=js"
import style0 from "./_task_info.vue?vue&type=style&index=0&id=4ad75a43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad75a43",
  null
  
)

export default component.exports